export default "__VITE_ASSET__Dxi2OugF__"